import { useQuery } from 'react-query';

import {
    Response,
    getActivityLevelDriversTornadoChart as queryFn,
} from 'api/endPoints/getActivityLevelDriversTornadoChart';
import { QueryKeys } from 'api/queryKeys';

export const useQueryActivityLevelDrivers = (params: QueryParams) => {
    return useQuery<Response, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['activityLevelDrivers', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.runQsra) && Boolean(params.taskVersionHashCode) && Boolean(params.metaDataId),
    });
};

interface QueryParams {
    metaDataId: number;
    numOfIterations: number;
    riskIds: number[];
    taskVersionHashCode: string;
    runQsra: boolean;
}

interface QueryResponse {
    tornadoResponse: {
        impactType: string;
        targetActivityId: string;
        targetActivityName: string;
        tornadoActivities: {
            activityId: string;
            activityName: string;
            impactValue: number;
            taskId: number;
        }[];
    }[];
}
